import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import { byDesign } from '@/infra/design'
import imgRenamejobUrl from '@/assets/misc/img_renamejob.svg'
import CreateTagIllustration from '@/components/SpotIllustration/CreateTagIllustration'

export interface RenameJobDialogProps {
  showing: boolean
  corporateMode: boolean
  isPending: boolean
  canSave: boolean
  onClose: () => unknown
  onSubmit: () => unknown
  children?: ReactNode
  confirmButtonTestId?: string
}

export function RenameJobDialog({
  showing,
  corporateMode,
  isPending,
  canSave,
  onClose,
  onSubmit,
  children,
  confirmButtonTestId,
}: RenameJobDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgRenamejobUrl}
              illustration={byDesign(undefined, CreateTagIllustration)}
              alt="Woman writing on a sign"
            />
          )}
          <ModalSheetContentTitle>Rename Job</ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Edit the job name
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <Form id="renameJob" onSubmit={() => onSubmit()}>
            {children}
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isPending}
            onPress={onClose}
            variant="default"
          />
          <Button
            label="Save"
            type="submit"
            form="renameJob"
            isPending={isPending}
            isDisabled={isPending || !canSave}
            variant="primary"
            testId={confirmButtonTestId}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
